const keyMirror = require("keymirror");

export const AccountConstants = keyMirror({
  FETCH_ACCOUNTS: undefined,
  FETCH_ROLES: undefined
});
